<template>
    <div id="help" class="py-5" align="center">
        <div id="fact-container" class=" px-4 py-4 bg-teal rounded-cust fadeInUp">
            Tired of getting a good score?? Try singing the song with the tune
            while typing the lyrics as fast as you can, that always makes it more
            fun. Also, did you try with Rap God by Eminem?
        </div>
    </div>
</template>

<script>
export default {
    name: "Help",
}
</script>

<style lang="scss">
#fact-container {
    width: 60%;
    font-size: 17px;
    font-weight: 500;

    @media only screen and (max-width: 850px) {
        width: 75%;
    }
    @media only screen and (max-width: 468px) {
        width: 82%;
    }
}
</style>